import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./landing/Header/Header";
import "./landing/Term/terms.scss";

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="mz-404">
        <p className="mz-404__code">404</p>
        <p className="mz-404__kicker">ERROR · PAGE NOT FOUND</p>
        <h1 className="mz-404__title">This page shipped elsewhere.</h1>
        <p className="mz-404__body">
          The page you are looking for was moved, renamed, or never existed. The homepage is a safe place to start.
        </p>
        <Link to="/" className="mz-btn mz-btn--dark mz-404__btn">
          Back to home
        </Link>
      </main>
    </>
  );
};

export default NotFound;
